





















































































































import { Component, Vue } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";
import YcColorPicker from "@/components/color-picker/index.js";
import pluginDialog from "../components/pluginDialog.vue";
import {
  saveWheelOfFortune,
  saveWheelOfFortuneDraft,
  getWheelOfFortuneDetail,
  getPopWindowTemplate,
  getPopWindowCopyDetail,
  getIsDeployJs,
  getQueryVariable
} from "@/services/api";
import Exhibition from '../components/exhibition.vue'
import styleSetting from './styleSetting/index.vue'
import discountSetting from './discountSetting.vue'
import rulesSetting from './rulesSetting.vue'
import popSetting from './popSetting.vue';
import {FormWheelOfFortuneSettingsVO, FormWheelSliceVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import { isFailMessage } from "@/i18n/failMessage";
import { localizeFormTemplateName } from "@/i18n/recommendCopy";
import store from "@/store";
import { getFontFaceList } from "@/utils/getFontFaceList";
import { getVueAppUploadApi } from "@/services/util";
enum permissionType {EDIT = 'edit', CHECK = 'check'}

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
    "yc-color-picker": YcColorPicker,
    'yc-exhibition': Exhibition,
    'style-setting': styleSetting,
    'discount-setting': discountSetting,
    'rules-setting': rulesSetting,
    'pop-setting': popSetting,
    pluginDialog,
  },
})
export default class wheelOfFortuneSetting extends Vue {
  testData:any={}
  // 大转盘数据
  public formData: TFormSaveDetailRequest = {};
  // 页面权限控制
  public permission = '';
  public permissionType = permissionType;
  // 激活的标签
  public activeTag = 'first';
  public activePageSetting = 'start';

  public templateName = '';
  public color =  '#000';
  public imgNameArr = [
    { imgName: 'left_top_', top: '20px', left: '20px' },
    { imgName: 'right_top_', top: '20px', right: '20px' },
    { imgName: 'left_center_', top: '47%', left: '20px' },
    { imgName: 'right_center_', top: '47%', right: '20px' },
    { imgName: 'left_bottom_', bottom: '20px', left: '20px' },
    { imgName: 'right_bottom_', bottom: '20px', right: '20px' }
  ]
  public selectImgVis = 1
  // 颜色选择色盘
  public predefineColors = [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    '#f1b859',
    '#f4994b',
    '#d7394d',
    '#dd5b46',
    '#f7d69e',
  ]
  public fontFaceList = getFontFaceList([
    {
      name: 'Arial',
      value: 'Arial, sans-serif',
      original: true
    },
    {
      name: 'Courier New',
      value: 'Courier New, monospace',
      original: true
    },
    {
      name: 'Georgia',
      value: 'Georgia, serif',
      original: true
    },
    {
      name: 'Times New Roman',
      value: 'Times New Roman, serif',
      original: true
    },
    {
      name: 'Trebuchet MS',
      value: 'Trebuchet MS, sans-serif',
      original: true
    },
    {
      name: 'Verdana',
      value: 'Verdana, sans-serif',
      original: true
    }
  ]);

  public tableData: FormWheelSliceVO[] = []
  public uploadShow = false;
  public uploadDialogVisible = false;
  public uploadDialogUrl = '';
  public uploadFileList: {name: string, url: string}[] = [];

  // 上传图片地址
  public uploadUrl = getVueAppUploadApi() + "/upload/formImage";
  get token() {
    return localStorage.getItem("token") || "default";
  }

  //发布、保存提交防止反复提交标记
  public repeatSave = false


  needInstallPlugin = false;
  plugInDialogShow = false;
  isShopify = false;


  get isEditAbTest() {
    return getQueryVariable('abtest') === 'true' && getQueryVariable('edit') === 'true';
  }

  get isAbTest() {
    return getQueryVariable('abtest') === 'true';
  }

  get currentAbtestIndex() {
    return parseInt(getQueryVariable('idx'));
  }

  jumpToList() {
    this.$router.push('/wheel_of_fortune/list');
  }

  backToAbtest() {
    this.$router.push(`/wheel_of_fortune/abtest/${getQueryVariable('abtestid')}`)
  }


  public checkPluginInstall() {
    this.plugInDialogShow = false;
    getIsDeployJs({}, false).then((res) => {
      if (res?.data?.data?.integrationType == 1) {
        this.isShopify = true;
        sessionStorage.setItem('isShopify', '1');
      } else {
        sessionStorage.setItem('isShopify', '0');
      }
      if (res?.data?.data?.integrationType == 1 || res?.data?.data?.integrationType == 11) {
        this.needInstallPlugin = !res?.data?.data?.deployJs;
      }
    });
  }
  public showPlugInDialog() {
    this.plugInDialogShow = true;
  }
  public closePluginDialog() {
    this.plugInDialogShow = false;
    this.needInstallPlugin = false;
    this.save();
  }
  public onlyClosePluginDialog() {
    this.plugInDialogShow = false;
  }


  async created(): Promise<void> {
    if(this.$route.path.match(new RegExp('^/wheel_of_fortune/check/[^/]*$'))) {
      this.permission = permissionType.CHECK;
    }
    if(this.$route.params.id) {
      await this.getWheelOfFortuneDetail(this.$route.params.id)
    } else if(this.$route.params.copyId) {
      await this.getPopWindowCopyDetail()
    } else {
      await this.getPopWindowTemplate()
    }
    this.checkPluginInstall();
  }

  changeActivePageSetting(value:string){
    this.activePageSetting = value
  }

  changeformData(val:any){
    this.formData = val;
     ((this.$refs.styleSetting as Vue).$refs.fortuneStyle as Vue).$forceUpdate();
  }


  /**
   * 新建大转盘初始信息
   */
  async getPopWindowTemplate(){
    let res = await getPopWindowTemplate({id:this.$route.query.templateid}, true)
    res.data.data.settings.position.iconUrl = ''
    this.formData = res.data.data;
    this.templateName = JSON.parse(JSON.stringify(res.data.data)).name
    this.generalFormNameRandomSuffix();
    this.formData.id = ''
    this.initSetting(this.formData.settings);
    sessionStorage.setItem('popType',res.data.data.type)
  }

  generalFormNameRandomSuffix() {
    let code = '';
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const pos = chars.length;
    for (let i = 0; i < 6; i++) {
      const idx = Math.floor(Math.random() * pos);
      code += chars.charAt(idx);
    }
    this.formData.name = localizeFormTemplateName(this.formData.name) + code;
  }


  /**
   * 获取大转盘详情
   */
  async getWheelOfFortuneDetail(id: string) {
    try {
      const res = await getWheelOfFortuneDetail({id}, true);
      if(!res.data.data.settings.position.iconUrl){
        res.data.data.settings.position.iconUrl = ''
      }
      this.formData = res.data.data;
      if (JSON.stringify(res.data.data.settings.targeting) !== '{}') {
        this.targeting = res.data.data.settings.targeting
      }
      this.initSetting(this.formData.settings);
      sessionStorage.setItem('popType', res.data.data.type);
      // console.log(this.formData, 'this.formDatathis.formDatathis--------.formDatathis.formData');
    } catch (e) {
      console.error('getWheelOfFortuneDetail error', e);
      if(String(e)?.indexOf('ID对应的数据不存在')>-1){
        window.location.replace(process.env.VUE_APP_DOMAIN + '/cartsee-new/dashboard')
      }
    }
  }

  async getPopWindowCopyDetail(){
    const res = await getPopWindowCopyDetail({id:this.$route.params.copyId}, true);
    if(!res.data.data.settings.position.iconUrl){
      res.data.data.settings.position.iconUrl = ''
    }
    this.formData = res.data.data;
    if (JSON.stringify(res.data.data.settings.targeting) !== '{}') {
      this.targeting = res.data.data.settings.targeting
    }
    this.initSetting(this.formData.settings);

  }

  /**
   * 设置初始化
   */
  initSetting(settings: FormWheelOfFortuneSettingsVO = {}) {
    if(!settings.styles) {
      settings.styles = {}
    }
    if (!settings.styles.styleMap) {
      settings.styles.styleMap = {}
    }
    if(!settings.position) {
      settings.position = {
        backgroundColor: '#FFFFFF',
        iconSizeType: 'Medium',
        iconShow: true,
        enableIconScrollAnimation: false,
      }
    }

    const defaultStyleMap: {[prop: string]: {[prop: string]: string}} = {
      'cartx-a-form-cell': {
        background: '#FFFFFF'
      },
      'cartx-a-wheel-label': {
        color: '#FFFFFF',
        'font-family': 'Arial, sans-serif'
      },
      'cartx-a-pointer-main-body': {
        fill: '#C13A4A'
      },
      'cartx-a-headline': {
        color: '#000000',
        'font-family': 'Trebuchet MS, sans-serif'
      },
      'cartx-a-success-headline': {
        color: '#000000',
        'font-family': 'Trebuchet MS, sans-serif'
      },
      'cartx-a-second-headline': {
        color: '#000000',
        'font-family': 'Trebuchet MS, sans-serif'
      },
      'cartx-a-success-second-headline': {
        color: '#000000',
        'font-family': 'Trebuchet MS, sans-serif'
      },
      'cartx-a-submit': {
        background: '#000000',
        color: '#FFFFFF',
        'font-family': 'Trebuchet MS, sans-serif'
      },
      'cartx-a-copy': {
        background: '#000000',
        color: '#FFFFFF',
        'font-family': 'Trebuchet MS, sans-serif'
      },
      'cartx-a-coupon-code': {
        color: '#000000',
        'font-family': 'Arial, sans-serif'
      },
      'cartx-a-coupon-bg': {
        fill: '#FFFFFF'
      },
      'cartx-a-gdpr-checkbox-container': {
        color: '#000000',
        'font-family': 'Trebuchet MS, sans-serif'
      },
      'cartx-a-checkbox-checkmark': {
        'border-color': '#000000',
        color: '#000000'
      },
      'cartx-a-close-first': {
        color: '#000000',
        'font-family': 'Trebuchet MS, sans-serif'
      },
      'cartx-a-close-success': {
        color: '#000000',
        'font-family': 'Trebuchet MS, sans-serif'
      }
    }
    for (let key of Object.keys(defaultStyleMap)) {
      settings.styles.styleMap[key] = {
        ...defaultStyleMap[key],
        ...settings.styles.styleMap[key]
      }
    }

    const positionVis = ['LeftTop', 'RightTop', 'LeftMiddle', 'RightMiddle', 'LeftBottom', 'RightBottom'].indexOf(settings.position.position||'')

    this.selectImgVis = positionVis == -1 ? 1: positionVis+1;

    const colorArr = ['#f1b859','#f4994b','#d7394d','#dd5b46','#f7d69e','#f1b859','#f4994b','#d7394d','#dd5b46','#f7d69e']
    settings.wheelSlices?.map((v,i) => v.color = v.color || colorArr[i]);
    this.uploadFileList = settings.position.iconUrl ? [{name: 'icon图标', url: settings.position.iconUrl}]: []

    // 展示的table和实际数据顺序不同
    this.tableData = [...(this.formData.settings?.wheelSlices||[])].reverse();
    const last = this.tableData.splice(this.tableData.length - 1, 1);
    this.tableData.unshift(...last);

    return settings;
  }

  changeTargetingData(val:any){
    this.formData.settings.targeting = val
  }




  /**
   * 下一步
   */
  nextStep() {
    switch (this.activeTag) {
      case 'first':
        switch (this.activePageSetting) {
          case 'start':
            if(this.SettingValid()) {
              this.activePageSetting = 'end';
            }
            break;
          case 'end':
            if(this.packUpValid()) {
              this.activePageSetting = 'packUp';
            }
            break;
          case 'packUp':
            if (this.sendValid()) {
              this.activeTag = 'second';
            }
            break;
          default:
            break;
        }
        break;
      case 'second':
        if(this.tableValid()){
          this.activeTag = 'third';
        }
        break;
      case 'third':
        this.activeTag = 'fourth';
        break;
      default:
        break;
    }
  }

  /**
   * 上一步
   */
  backStep() {
    switch (this.activeTag) {
      case 'first':
        switch (this.activePageSetting) {
          case 'start':
            this.$router.push('/wheel_of_fortune/list');
            break;
          case 'end':
            this.activePageSetting = 'start'
            break;
          case 'packUp':
            this.activePageSetting = 'end'
            break;
          default:
            break;
        }
        break;
      case 'second':
        this.activePageSetting = 'packUp'
        this.activeTag = 'first';
        break;
      case 'third':
        this.activeTag = 'second';
        break;
      case 'fourth':
        this.activeTag = 'third';
        break;
      default:
        break;
    }
  }

  showCancelDialog = false;
  /**
   * 取消
   */
  cancel() {
    switch (this.activeTag) {
      case 'first':
        switch (this.activePageSetting) {
          case 'start':
            this.showCancelDialog = true;
            // this.$router.push('/wheel_of_fortune/list');
            break;
          case 'end':
            this.activePageSetting = 'start'
            break;
          case 'packUp':
            this.activePageSetting = 'end'
            break;
          default:
            break;
        }
        break;
      case 'second':
        this.activePageSetting = 'packUp'
        this.activeTag = 'first';
        break;
      case 'third':
        this.activeTag = 'second';
        break;
      default:
        break;
    }
  }

  confirmCancel() {
    this.showCancelDialog = false;
    if (this.isAbTest) {
      if (this.isEditAbTest) {
        this.$router.push(`/wheel_of_fortune/abtest/${getQueryVariable('abtestid')}`)
      } else {
        window.close();
      }
    } else {
      this.$router.push('/wheel_of_fortune/list');
    }
  }

  /**
   * 设置校验
   */
  SettingValid() {
    if (!this.formData.name) {
      this.activePageSetting = 'start'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.wheelNameCannotBeEmpty', '转盘名称不能为空'))
      this.$nextTick(() => {
        const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelName;
        wheelNameEl.focus();
      })
      return false;
    }
    if(!this.formData?.settings?.gdpr?.text) {
      this.activePageSetting = 'start'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.consentTextCannotBeEmpty', '同意订阅文字不能为空'))
      this.$nextTick(() => {
        const gdprEl: any =  this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.gdpr;
        gdprEl.focus();
      })
      return false;
    }
    if(!this.formData?.settings?.texts?.spinButton) {
      this.activePageSetting = 'start'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.buttonTextCannotBeEmpty', '按钮文字不能为空'))
      this.$nextTick(() => {
        const spinButtonEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.spinButton;
        spinButtonEl.focus();
      })
      return false;
    }
    if(!this.formData?.settings?.texts?.thanksAlreadySubscribed) {
      this.activePageSetting = 'start'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.textAlreadySubscribedUsersCannot', '已订阅用户提示文字不能为空'))
      this.$nextTick(() => {
        const thanksAlreadySubscribedButtonEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.thanksAlreadySubscribedButton;
        thanksAlreadySubscribedButtonEl.focus();
      })
      return false;
    }

    return true;
  }

  packUpValid() {
    return true;
  }

  sendValid() {
    if (
      this.formData.settings.position?.iconCustom &&
      (this.formData.settings.position?.iconCustomBottom === undefined || typeof +this.formData.settings.position?.iconCustomBottom !== 'number' || isNaN(+this.formData.settings.position?.iconCustomBottom))
    ) {
      this.$message.warning(this.$tx('form.edit.err.marginEmpty', '自定义边距值不可为空'))
      return false
    }
    return true;
  }

  /**
   * 表格校验
   */
  tableValid() {
    for (let item of this.tableData || []) {
      if (!item.label) {
        this.activeTag = 'second';
        this.$message.warning(this.$tx('form.pleaseEnterPrizeSliceText', '请填写奖区文案'));
        this.$nextTick(() => {
          const ele: any = this.$refs.discountSetting.$refs['label' + item.index];
          ele.focus();
        })
        return false;
      } else if (item.type === 'winning' && !(!!item.couponCode || !!item.discount)) {
        this.activeTag = 'second';
        this.$message.warning(this.$tx('form.pleaseEnterCouponCode', '请填写coupon code'));
        this.$nextTick(() => {
          const ele: any = this.$refs.discountSetting.$refs['couponCode' + item.index];
          ele.focus();
        })
        return false;
      }
      if(this.formData.settings?.wheelSlices?.reduce((a,i)=>a+=(i.probability = i.probability||0),0) !== 100) {
        this.activeTag = 'second';
        this.$message.warning(this.$tx('form.sumProbabilitiesMustEqual100', '概率加和必须等于100'));
        this.$nextTick(() => {
          const ele: any = this.$refs.discountSetting.$refs['probability1'];
          ele.focus();
        })
        return false;
      }
    }
    return true;
  }

  showSaveDraftDialog = false;
  confirmSaveDraft() {
    this.showSaveDraftDialog = true;
  }


  /**
   * 保存草稿
   */
  saveDraft() {
    if(this.templateName){
      window.gtag('event', 'subscribe-tool_create_draft', {
        event_name:'订阅工具保存为草稿',
        event_type:'按钮点击',
        event_des:'订阅工具保存为草稿',
        subscribe_type:this.templateName,
        Company_id:JSON.parse(localStorage.getItem('companyInfo'))?.id,
        os_type:JSON.parse(localStorage.getItem('osInfo'))?.os,
        os_version:JSON.parse(localStorage.getItem('osInfo'))?.version,
        browser_type:JSON.parse(localStorage.getItem('browserInfo'))?.browser,
        browser_version:JSON.parse(localStorage.getItem('browserInfo'))?.version,
        conutry:localStorage.getItem('countryName'),
        time:new Date()
      });
    }
    this.showSaveDraftDialog = false;
    if(this.repeatSave){
      return
    }
    this.repeatSave = true


    if (!this.SettingValid() || !this.tableValid() || !this.packUpValid()) {
      this.repeatSave = false
      return;
    }
    if (this.$route.query.templateid) {
      this.formData.templateId = Number(this.$route.query.templateid) || 1;
    }
    // this.formData.templateId = Number(this.$route.query.templateid) || 1
    this.formData.settings.position.iconShow = Number(this.formData.settings.position.iconShow);
    saveWheelOfFortuneDraft(this.formData, true).then((res) => {
      this.$message({
        message: this.$tx('common.success.draft', '保存草稿成功'),
        center: true,
        type: 'success'
      });
      store.commit('DELETE_SUGGEST_MAP', 'form_ids');
      if (this.isAbTest) {
        this.$router.push(`/wheel_of_fortune/abtest/${getQueryVariable('abtestid')}`)
      } else {
        this.$router.push('/wheel_of_fortune/list');
      }
      // this.$router.push('/wheel_of_fortune/list');
    }).catch(error => {
      if (isFailMessage(error, '名称不能相同，请修改！')) {
        // 如果名称相同，自动跳转并修改
        this.activePageSetting = 'start';
        this.activeTag = "first";
        this.$nextTick(() => {
          const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelName
          wheelNameEl && wheelNameEl.focus();
        })
      }
      this.repeatSave = false
    });
  }

  /**
   * 发布
   */
  save() {
    if(this.templateName){
      window.gtag('event', 'subscribe-tool_create_finish', {
        event_name:'订阅工具完成创建',
        event_type:'按钮点击',
        event_des:'订阅工具完成创建',
        subscribe_type:this.templateName,
        Company_id:JSON.parse(localStorage.getItem('companyInfo'))?.id,
        os_type:JSON.parse(localStorage.getItem('osInfo'))?.os,
        os_version:JSON.parse(localStorage.getItem('osInfo'))?.version,
        browser_type:JSON.parse(localStorage.getItem('browserInfo'))?.browser,
        browser_version:JSON.parse(localStorage.getItem('browserInfo'))?.version,
        conutry:localStorage.getItem('countryName'),
        time:new Date()
      });
    }
    if (this.needInstallPlugin) {
      this.showPlugInDialog();
      return;
    }
    if(this.repeatSave){
      return
    }
    this.repeatSave = true

    if (!this.SettingValid() || !this.tableValid() || !this.packUpValid()) {
      this.repeatSave = false
      return;
    }

    if (this.$route.query.templateid) {
      this.formData.templateId = Number(this.$route.query.templateid) || 1;
    }
    // this.formData.templateId = Number(this.$route.query.templateid) || 1

    this.formData.settings.position.iconShow = Number(this.formData.settings.position.iconShow);
    saveWheelOfFortune(this.formData, true).then((res) => {
      this.$message({
        message: this.$tx('common.success.publish', '发布成功'),
        center: true,
        type: 'success'
      });
      store.commit('DELETE_SUGGEST_MAP', 'form_ids');
      this.$router.push('/wheel_of_fortune/list');
    }).catch(error => {
      if (isFailMessage(error, '名称不能相同，请修改！')) {
        // 如果名称相同，自动跳转并修改
        this.activePageSetting = 'start';
        this.activeTag = "first";
        this.$nextTick(() => {
          const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelName
          wheelNameEl && wheelNameEl.focus();
        })
      }
      this.repeatSave = false
    });
  }

}
